import React from 'react';
import CustomFilter from './FilterPDL/CustomFilter';
import DashboardMain_Bus from "../../DashboardMain_Bus/DashboardMain_Bus"
import TablePDL from './LostPDLTable/TablePDL';
import KpisPDL from './Kpis/KPI';
import AgeingDistribution from './Kpis/AgingGraph/AgeingDistribution';
import { PDLContextProvider } from './Context';

const PDLHomePage = () => {
    return (
        <PDLContextProvider>
            <DashboardMain_Bus >
                <div className='container-fluid busdrpg1'>
                    <CustomFilter />
                    <KpisPDL />
                    {/* <AgeingDistribution /> */}
                    <TablePDL />
                </div>
            </DashboardMain_Bus>
        </PDLContextProvider>
    );
}

export default PDLHomePage;
